import _ from "lodash"
import moment from "moment"
import {post,} from "../api_helper"
import { node } from "../../config.js"
import {getSession, setSession} from "../AuthType/authService"
import {decrypt,} from "../../common/global/functions.js"

const baseUrl =
  process.env.REACT_APP_PRODUCTION === "prod"
    ? node.baseUrl
    : process.env.REACT_APP_PRODUCTION === "stage"
    ? node.stageUrl
    : node.devUrl
const tokenKey = "token"
const session = "session"
const authUser = "authUser"
const sessionExpire = "sessionExpire"
const sessionTimeout = "sessionTimeout"

function fnSetAppSession(data) {
  try {
    let session = getSession();
    
    if(data){
      data = _.mapValues(data, function(value, key) {
        return _.isObject(value) ? value.value : value;
      });
  
      session.app = _.merge(session.app, data);
  
      setSession(session)
    }

    return session.app
  } catch (error) {
    throw new Error(error.message)
  }
}

/*
ssnTestSubjectVerification
*/
export async function fnSsnTestSubjectVerification(ssn) {
  try {
    ssn = ssn.replace(/[^0-9]/g, "")

    let url = baseUrl + node.application.fnSsnTestSubjectVerification.url;

    let response = await post(url, { ssn })
    return response
  } catch (error) {
    if (
      _.has(error, "response") &&
      _.has(error.response, "data") &&
      error.response.data
    ) {
      throw new Error(error.response.data)
    } else {
      throw new Error(error.message)
    }
  }
}

export async function fnAddressVerification({ addr, addr2, city, state, zipcode,}) {
  
  try {
    let url = baseUrl + node.application.fnAddressVerification.url,
    address = { street : _.concat(addr,addr2).join(" ").trim(), city : city.trim(), state : state.trim(), zipcode : zipcode.trim(), };

    let { addressElements } = await post(url, { address,})

    if (_.isUndefined(addressElements))
      return {
        addressVerification: {
          timestamp: moment().unix(),
          addressMatch: false,
          requestedAddress: _.concat(address.street,address.city,address.state,address.zipcode).join(" "),
          requested : address,
          dpvConfirmation : false
        },
      }

    let {
      dpvConfirmation,
      formattedAddress,
      formatted,
      requestedAddress,
      requested,
      components,
    } = addressElements

    return {
      addressVerification: {
        dpvConfirmation,
        requestedAddress,
        requested,
        formattedAddress,
        formatted,
        components,
        addressMatch: _.isEqual(requested, formatted),
        timestamp: moment().unix(),
      },
    }
  
  } catch (ex) {
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
    throw new Error(message)
  }
}

export function fnUpdateAddress({applicantType, address : { street : addr , city, state, zipcode,}}) {
  try {
    let session = getSession();

    session.app = _.merge(session.app, {addr, city, state, zipcode,});

    setSession(session)

    return session.app;   
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnSetPersonalInformation(data) {
  
  try {
    return await fnAddressVerification(fnSetAppSession(data));   
  } catch (error) {
    throw new Error(error.message)
  }
}

export function fnSetIncomeInformation(data) {
  
  try {
    return fnSetAppSession(data);   
  } catch (error) {
    throw new Error(error.message)
  }
}

export function fnSetResidencyInformation(data) {
  
  try {
    return fnSetAppSession(data); 
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnSetReferenceInformation({ applicantType, reference}) {
  
  try {
    let data = fnSetAppSession(reference);
    let {id, url_identifier} = await fnSignUp(data); 
    return fnSetAppSession({...data, id, url_identifier}); 
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnSignUp(data) {
  try {
    let url = baseUrl + node.application.fnSetSignUp.url;

    let {id, url_identifier} = await post(url, data);

    return {id, url_identifier}
  } catch (error) {
    if (
      _.has(error, "response") &&
      _.has(error.response, "data") &&
      error.response.data
    ) {
      throw new Error(error.response.data)
    } else {
      throw new Error(error.message)
    }
  }
}

export async function fnDeliverAccessCode({ applicantType, access_code_method}) {
  
  try {
    
    let data, response, value, label, access_code = {}, regex = /phone/, url = baseUrl + node.application.fnDeliverAccessCode.url;

    ({value, label} = access_code_method);

    let {app, merchant} = getSession();
    
    response = await post(
      url, 
      {
        value : app[`${value}`], 
        //method : regex.test(data.access_code_method) ? `sms` : `email`,
        method : value.includes("phone") ? `sms` : `email`,
        app,
        merchant,
      }
    );

    data = fnSetAppSession({access_code_method : value, access_code_encrypted : response});

    return data;
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnValidateAccessCode({ applicantType, data}) {
  
  try {

    let {access_code} = data, {app, merchant} = getSession(),
    url = baseUrl + node.application.fnApplicationCompleteEmail.url,
    response;


    if(!_.isEqual(String(decrypt(app.access_code_encrypted)), access_code))
      throw new Error(`Invaid access code`)
    
    response = await post(
      url, 
      {
        app,
        merchant,
      }
    );

    app = fnSetAppSession({access_code_validated : true});
    
    return app;
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnStartCoSigner({ applicantType, data}) {
  
  try {
    console.log({applicantType, data})
    return data;
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnInviteCoEmail({ applicantType, data}) {  
  try {
    let {app, merchant} = getSession(), {email, firstname, lastname, url_identifier} = data,
    url = baseUrl + node.application.fnInviteCoEmail.url,
    response;
    
    response = await post(
      url, 
      {
        email, 
        firstname, 
        lastname,
        url_identifier,
        app,
        merchant,
      }
    );
    return response;
  } catch (error) {
    throw new Error(error.message)
  }
}

export async function fnInviteCoSms({ applicantType, data}) {  
  try {
    let {app, merchant} = getSession(), {firstname, lastname, cellphone, url_identifier} = data,
    url = baseUrl + node.application.fnInviteCoSms.url,
    response, counter;
    
    response = await post(
      url, 
      {
        cellphone, 
        firstname, 
        lastname,
        url_identifier,
        app,
        merchant,
      }
    );

    counter = _.has(app,'invite_co_sms_counter') ? app.invite_co_sms_counter + 1 : 1;

    app = fnSetAppSession({invite_co_sms_counter : counter});
    
    return app;
  } catch (error) {
    throw new Error(error.message)
  }
}